import React from 'react'
import { Input, Select, DatePicker, Space } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

const { Option } = Select
const { RangePicker } = DatePicker

const TaskFilters = ({ filterValues, filterState }) => {
  const {
    searchText,
    setSearchText,
    statusFilter,
    setStatusFilter,
    priorityFilter,
    setPriorityFilter,
    categoryFilter,
    setCategoryFilter,
    dateRange,
    setDateRange
  } = filterState

  const { categories, priorities, statuses } = filterValues

  return (
    <div style={{ marginBottom: '16px', display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center' }}>
      <Input
        placeholder='Search by patient, task, or staff'
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ width: 250 }}
        prefix={<SearchOutlined />}
        allowClear
      />

      <Select
        placeholder='Status'
        style={{ width: 150 }}
        value={statusFilter}
        onChange={(value) => setStatusFilter(value)}
      >
        <Option value='all'>All Statuses</Option>
        {statuses.map((status) => (
          <Option key={status} value={status}>
            {status}
          </Option>
        ))}
      </Select>

      <Select
        placeholder='Priority'
        style={{ width: 150 }}
        value={priorityFilter}
        onChange={(value) => setPriorityFilter(value)}
      >
        <Option value='all'>All Priorities</Option>
        {priorities.map((priority) => (
          <Option key={priority} value={priority}>
            {priority}
          </Option>
        ))}
      </Select>

      <Select
        placeholder='Category'
        style={{ width: 180 }}
        value={categoryFilter}
        onChange={(value) => setCategoryFilter(value)}
      >
        <Option value='all'>All Categories</Option>
        {categories.map((category) => (
          <Option key={category} value={category}>
            {category}
          </Option>
        ))}
      </Select>

      <RangePicker
        onChange={(dates) => setDateRange(dates)}
        value={dateRange}
        style={{ width: 280 }}
        placeholder={['Due Date From', 'Due Date To']}
      />
    </div>
  )
}

export default TaskFilters
